import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OrderTypeDashboardPage" */
	'pages/supplier/OrderType/OrderTypeDashboardPage'));

export default [{ component, exact: true, path: '/order_types/:orderTypeId' }];